import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import { HeadcountSnapshotStore } from '../../components/headcount/store/headcountSnapshotStore';
import { HeadcountYearlyTrendStore } from '../../components/headcount/store/headcountYearlyTrendStore';
import authConfig, { ANALYTICS_MENU_GROUP } from '../authConfig';

export const HeadcountPageConfig: ReactPageConfig = {
  name: 'src.config.routesConfigs.headcountPageConfig.name',
  path: 'headcount-dashboard',
  component: lazy(() => import('../../components/pages/HeadcountDashboardPage')),
  allowedRoles: [ authConfig.roles.ADMIN ],
  storeDependencies: [
    { store: HeadcountSnapshotStore },
    { store: HeadcountYearlyTrendStore },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/InsertChartOutlined')),
    label: 'src.config.routesConfigs.headcountPageConfig.label',
    group: ANALYTICS_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
